import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Constants } from '@app/shared-module/constants';

@Injectable({
  providedIn: 'root'
})
export class ExtraService {

  constructor(
    private httpClient: HttpClient
  ) { }
  activateDoctor(doctorID: string, status: string) {
    const body = {
      status
    };
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.DOCTOR_ACTIVATE_API + doctorID, body);
  }
}
